import { ArrowUpRight } from "lucide-react";
import { ScrollReveal } from "./Reveal";
import { LINKS } from "@/constants/links";

const nav = ["Home", "Work", "Services", "About", "Contact"];

export const Footer = () => {
  const socials = [
    { label: "YouTube", href: LINKS.youtube },
    { label: "Instagram", href: LINKS.instagram },
    { label: "TikTok", href: LINKS.tiktok },
  ];

  return (
    <footer data-testid="footer" className="border-t border-white/10 bg-[#0A0A0A] pt-20 pb-10 overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <ScrollReveal>
          <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-10">
            <div>
              <h2 className="font-display leading-[0.9] text-[16vw] lg:text-[10vw]">Etia Media</h2>
              <p className="font-mono2 text-[11px] uppercase tracking-[0.3em] text-[#8A8A85] mt-6">
                UK — Available for projects across the UK.
              </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-10">
              <div className="flex flex-col gap-3">
                {nav.map((n) => (
                  <button
                    key={n}
                    data-testid={`footer-nav-${n.toLowerCase()}`}
                    onClick={() => {
                      const target = n === "Home" ? null : `#${n.toLowerCase()}`;
                      if (target === "#contact") return window.__openEnquiry();
                      if (target) {
                        if (window.__scrollToId) window.__scrollToId(target);
                        else document.querySelector(target)?.scrollIntoView({ behavior: "smooth" });
                      } else if (window.__lenis) window.__lenis.scrollTo(0, { duration: 1.2 });
                      else window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                    className="text-left font-mono2 text-xs uppercase tracking-[0.25em] text-[#8A8A85] hover:text-[#F2F0EB] transition-colors duration-300"
                  >
                    {n}
                  </button>
                ))}
              </div>
              <div className="flex flex-col gap-3">
                {socials.map((s) => (
                  <a
                    key={s.label}
                    data-testid={`footer-social-${s.label.toLowerCase()}`}
                    href={s.href}
                    target={s.href.startsWith("http") ? "_blank" : undefined}
                    rel="noopener noreferrer"
                    onClick={s.href === "#" ? (e) => e.preventDefault() : undefined}
                    className="group flex items-center gap-2 font-mono2 text-xs uppercase tracking-[0.25em] text-[#8A8A85] hover:text-[#F2F0EB] transition-colors duration-300"
                  >
                    {s.label}
                    <ArrowUpRight className="w-3.5 h-3.5 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-300" />
                  </a>
                ))}
              </div>
            </div>
          </div>
        </ScrollReveal>

        <div className="mt-16 pt-8 border-t border-white/10">
          <p className="font-mono2 text-[11px] uppercase tracking-[0.25em] text-[#55554F]">
            © 2026 Etia Media. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
